// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTop_button__ewsXf","show":"ScrollToTop_show__htVmb","hide":"ScrollToTop_hide__RJ3kB"};